module.exports = __webpack_public_path__ + "img/blues_bg.5da826c8.png";